import {
    amber,
    blue,
    blueGrey,
    brown,
    deepPurple,
    green,
    grey,
    indigo,
    orange,
    pink,
    purple,
    red,
    teal,
    yellow,
} from "@mui/material/colors";

export type SoftColor = {
    bg: string;
    class: string;
    hover: string;
    text: string;
};
export const softColors: Record<string, SoftColor> = {
    indigo: {
        bg: indigo[50],
        class: indigo[100],
        hover: indigo[400],
        text: indigo[800],
    },
    teal: {
        bg: teal[50],
        class: teal[100],
        hover: teal[400],
        text: teal[800],
    },
    blue: {
        class: blue[100],
        bg: blue[50],
        hover: blue[400],
        text: blue[800],
    },
    green: {
        bg: green[50],
        class: green[100],
        hover: green[400],
        text: green[800],
    },
    purple: {
        bg: purple[50],
        class: purple[100],
        hover: purple[400],
        text: purple[800],
    },
    deepPurple: {
        bg: deepPurple[50],
        class: deepPurple[100],
        hover: deepPurple[400],
        text: deepPurple[800],
    },
    orange: {
        bg: orange[50],
        class: orange[100],
        hover: orange[400],
        text: orange[800],
    },
    pink: {
        bg: pink[50],
        class: pink[100],
        hover: pink[400],
        text: pink[800],
    },
    brown: {
        bg: brown[50],
        class: brown[100],
        hover: brown[400],
        text: brown[800],
    },
    yellow: {
        bg: yellow[50],
        class: yellow[100],
        hover: yellow[700],
        text: yellow[900],
    },
    amber: {
        bg: amber[50],
        class: amber[100],
        hover: amber[400],
        text: amber[800],
    },
    red: {
        bg: red[50],
        class: red[100],
        hover: red[400],
        text: red[800],
    },
    blueGrey: {
        bg: blueGrey[50],
        class: blueGrey[100],
        hover: blueGrey[400],
        text: blueGrey[800],
    },
    grey: {
        bg: grey[50],
        class: grey[100],
        hover: grey[400],
        text: grey[800],
    },
};

// datasets: [
//     // Gradient stacked bars - Soft mavi tonları
//     {
//         type: "bar" as const,
//         label: "Geliş",
//         data: chartData.map((d) => d.arrivalCompleted),
//         backgroundColor: "rgba(99, 102, 241, 0.85)", // indigo-500 - daha soft
//         borderColor: "rgba(99, 102, 241, 0.95)",
//         borderWidth: 0,
//         borderSkipped: false,
//         stack: "stack0",
//         hoverBackgroundColor: "rgba(99, 102, 241, 1)",
//         hoverBorderColor: "rgba(99, 102, 241, 1)",
//         hoverBorderWidth: 3,
//         hoverRadius: [12, 12, 0, 0], // Hover'da da sadece üst köşeler
//         hoverBorderRadius: [12, 12, 0, 0],
//     },
//     {
//         type: "bar" as const,
//         label: "Geliş İptal", // Tooltip'te görünür
//         data: chartData.map((d) => d.arrivalCanceled),
//         backgroundColor: "rgba(129, 140, 248, 0.8)", // indigo-400 - orta ton
//         borderColor: "rgba(129, 140, 248, 0.9)",
//         borderWidth: 0,
//         borderSkipped: false,
//         stack: "stack0",
//         hoverBackgroundColor: "rgba(129, 140, 248, 1)",
//         hoverBorderColor: "rgba(129, 140, 248, 1)",
//         hoverBorderWidth: 3,
//         hoverRadius: 12,
//         hoverBorderRadius: 12,
//     },
//     {
//         type: "bar" as const,
//         label: "Geliş No-Show", // Tooltip'te görünür
//         data: chartData.map((d) => d.arrivalNoShow),
//         backgroundColor: "rgba(165, 180, 252, 0.75)", // indigo-300 - açık ton
//         borderColor: "rgba(165, 180, 252, 0.85)",
//         borderWidth: 0,
//         borderSkipped: false,
//         stack: "stack0",
//         hoverBackgroundColor: "rgba(165, 180, 252, 1)",
//         hoverBorderColor: "rgba(165, 180, 252, 1)",
//         hoverBorderWidth: 3,
//         hoverRadius: 12,
//         hoverBorderRadius: 12,
//     },
//     {
//         type: "bar" as const,
//         label: "Gidiş",
//         data: chartData.map((d) => d.departureCompleted),
//         backgroundColor: "rgba(34, 197, 94, 0.85)", // emerald-500 - daha soft
//         borderColor: "rgba(34, 197, 94, 0.95)",
//         borderWidth: 0,
//         borderSkipped: false,
//         stack: "stack0",
//         hoverBackgroundColor: "rgba(34, 197, 94, 1)",
//         hoverBorderColor: "rgba(34, 197, 94, 1)",
//         hoverBorderWidth: 3,
//         hoverRadius: [12, 12, 0, 0], // Hover'da da sadece üst köşeler
//         hoverBorderRadius: [12, 12, 0, 0],
//     },
//     {
//         type: "bar" as const,
//         label: "Gidiş İptal", // Tooltip'te görünür
//         data: chartData.map((d) => d.departureCanceled),
//         backgroundColor: "rgba(52, 211, 153, 0.8)", // emerald-400 - orta ton
//         borderColor: "rgba(52, 211, 153, 0.9)",
//         borderWidth: 0,
//         borderSkipped: false,
//         stack: "stack0",
//         hoverBackgroundColor: "rgba(52, 211, 153, 1)",
//         hoverBorderColor: "rgba(52, 211, 153, 1)",
//         hoverBorderWidth: 3,
//         hoverRadius: 12,
//         hoverBorderRadius: 12,
//     },
//     {
//         type: "bar" as const,
//         label: "Gidiş No-Show", // Tooltip'te görünür
//         data: chartData.map((d) => d.departureNoShow),
//         backgroundColor: "rgba(110, 231, 183, 0.75)", // emerald-300 - açık ton
//         borderColor: "rgba(110, 231, 183, 0.85)",
//         borderWidth: 0,
//         borderSkipped: false,
//         stack: "stack0",
//         hoverBackgroundColor: "rgba(110, 231, 183, 1)",
//         hoverBorderColor: "rgba(110, 231, 183, 1)",
//         hoverBorderWidth: 3,
//         hoverRadius: 12,
//         hoverBorderRadius: 12,
//     },
//     // Gradient line chart - Smooth geçişli çizgi
//     {
//         type: "line" as const,
//         label: "", // Boş label - legend'da görünmez
//         data: totalData,
//         borderColor: "rgba(99, 102, 241, 0.9)", // Ana çizgi rengi - indigo
//         backgroundColor: "rgba(99, 102, 241, 0.08)", // Çok hafif gradient
//         borderWidth: 3,
//         tension: 0.5, // Daha smooth çizgi
//         pointRadius: 5,
//         pointBackgroundColor: totalData.map((_, index) => {
//             // Gradient renk geçişi - indigo'dan emerald'a
//             const colors = [
//                 "rgba(99, 102, 241, 1)", // indigo-500
//                 "rgba(129, 140, 248, 1)", // indigo-400
//                 "rgba(165, 180, 252, 1)", // indigo-300
//                 "rgba(34, 197, 94, 1)", // emerald-500
//                 "rgba(52, 211, 153, 1)", // emerald-400
//                 "rgba(110, 231, 183, 1)", // emerald-300
//             ];
//             return colors[index % colors.length];
//         }),
//         pointBorderColor: "#ffffff",
//         pointBorderWidth: 3,
//         pointHoverRadius: 8,
//         pointHoverBorderWidth: 4,
//         pointHoverBorderColor: "#ffffff",
//         pointHoverBackgroundColor: "rgba(99, 102, 241, 1)",
//         fill: true,
//         order: 0,

export type DashboardColor = {
    primary: string;
    border: string;
    hoverBg: string;
    hoverBorder: string;
};
export const dashboardColors: Record<string, DashboardColor> = {
    indigo: {
        primary: "rgba(99, 102, 241, 0.85)",
        border: "rgba(99, 102, 241, 0.95)",
        hoverBg: "rgba(99, 102, 241, 1)",
        hoverBorder: "rgba(99, 102, 241, 1)",
    },
    indigoLight: {
        primary: "rgba(129, 140, 248, 0.8)",
        border: "rgba(129, 140, 248, 0.9)",
        hoverBg: "rgba(129, 140, 248, 1)",
        hoverBorder: "rgba(129, 140, 248, 1)",
    },
    indigoLightest: {
        primary: "rgba(165, 180, 252, 0.75)",
        border: "rgba(165, 180, 252, 0.85)",
        hoverBg: "rgba(165, 180, 252, 1)",
        hoverBorder: "rgba(165, 180, 252, 1)",
    },
    emerald: {
        primary: "rgba(34, 197, 94, 0.85)",
        border: "rgba(34, 197, 94, 0.95)",
        hoverBg: "rgba(34, 197, 94, 1)",
        hoverBorder: "rgba(34, 197, 94, 1)",
    },
    emeraldLight: {
        primary: "rgba(52, 211, 153, 0.8)",
        border: "rgba(52, 211, 153, 0.9)",
        hoverBg: "rgba(52, 211, 153, 1)",
        hoverBorder: "rgba(52, 211, 153, 1)",
    },
    emeraldLightest: {
        primary: "rgba(110, 231, 183, 0.75)",
        border: "rgba(110, 231, 183, 0.85)",
        hoverBg: "rgba(110, 231, 183, 1)",
        hoverBorder: "rgba(110, 231, 183, 1)",
    },
    orange: {
        primary: "rgba(251, 146, 60, 0.85)",
        border: "rgba(251, 146, 60, 0.95)",
        hoverBg: "rgba(251, 146, 60, 1)",
        hoverBorder: "rgba(251, 146, 60, 1)",
    },
};
